import Api from '.';

class UserInviteApi extends Api {
  base_endpoint = 'invites';

  resend(id) {
    return this.doRequest('post', `resend`, { id });
  }
}

export default new UserInviteApi();
